import {madnes_fill_range, madnes_join} from "../framework/src/engine/madnes/madnes";

var in_smoke_pos = 0;
var lines = new Array();

var render_move_per_sec = 16; // Symbolu za sekundu
var render_move_per_sec_free = 26; // Symbolu za sekundu ve free spinu

export var cylinder_pos = new Array();
cylinder_pos[0] = 76;
cylinder_pos[1] = 460;
cylinder_pos[2] = 850;


export var freepanelpos = 200;
export function set_freepanelpos(val) {
    freepanelpos = val;
}

export var icons = {
    "symbol_BAR": {
        stop: [0],
        //anim: madnes_join(madnes_fill_range(0, 34),[0])
        anim: madnes_join(madnes_fill_range(0, 29),[0])
    },
    "symbol_bell": {
        stop: [0],
        //anim: madnes_join(madnes_fill_range(0, 34),[0])
        anim: madnes_join(madnes_fill_range(0, 29),[0])
    },
    "symbol_dollar": {
        stop: [0],
        //anim: madnes_join(madnes_fill_range(0, 34),[0])
        anim: madnes_join(madnes_fill_range(0, 29),[0])
    },
    "symbol_grapes": {
        stop: [0],
        //anim: madnes_join(madnes_fill_range(0, 34),[0])
        anim: madnes_join(madnes_fill_range(0, 29),[0])
    },
    "symbol_cherry": {
        stop: [0],
        //anim: madnes_join(madnes_fill_range(0, 34),[0])
        anim: madnes_join(madnes_fill_range(0, 29),[0])
    },
    "symbol_melone": {
        stop: [0],
        //anim: madnes_join(madnes_fill_range(0, 34),[0])
        anim: madnes_join(madnes_fill_range(0, 29),[0])
    },
    "symbol_orange": {
        stop: [0],
        //anim: madnes_join(madnes_fill_range(0, 34),[0])
        anim: madnes_join(madnes_fill_range(0, 29),[0])
    },
    "symbol_plum": {
        stop: [0],
        //anim: madnes_join(madnes_fill_range(0, 34),[0])
        anim: madnes_join(madnes_fill_range(0, 29),[0])
    },
    "symbol_star": {
        stop: [0],
        //anim: madnes_join(madnes_fill_range(0, 34),[0])
        anim: madnes_join(madnes_fill_range(0, 29),[0])
    },


    "symbol_BAR_freeze": {
        stop: [0],
        //anim: madnes_fill_range(0, 34)
        anim: madnes_fill_range(0, 29)
    },
    "symbol_bell_freeze": {
        stop: [0],
        //anim: madnes_fill_range(0, 34)
        anim: madnes_fill_range(0, 29)
    },
    "symbol_dollar_freeze": {
        stop: [0],
        //anim: madnes_fill_range(0, 34)
        anim: madnes_fill_range(0, 29)
    },
    "symbol_grapes_freeze": {
        stop: [0],
        //anim: madnes_fill_range(0, 34)
        anim: madnes_fill_range(0, 29)
    },
    "symbol_cherry_freeze": {
        stop: [0],
        //anim: madnes_fill_range(0, 34)
        anim: madnes_fill_range(0, 29)
    },
    "symbol_melone_freeze": {
        stop: [0],
        //anim: madnes_fill_range(0, 34)
        anim: madnes_fill_range(0, 29)
    },
    "symbol_orange_freeze": {
        stop: [0],
        //anim: madnes_fill_range(0, 34)
        anim: madnes_fill_range(0, 29)
    },
    "symbol_plum_freeze": {
        stop: [0],
        //anim: madnes_fill_range(0, 34)
        anim: madnes_fill_range(0, 29)
    },
    "symbol_star_freeze": {
        stop: [0],
        //anim: madnes_fill_range(0, 34)
        anim: madnes_fill_range(0, 29)
    },


    "symbol_BAR_boom": {
        stop: [0],
        //anim: madnes_fill_range(0, 34)
        anim: madnes_fill_range(0, 24)
    },
    "symbol_bell_boom": {
        stop: [0],
        //anim: madnes_fill_range(0, 34)
        anim: madnes_fill_range(0, 24)
    },
    "symbol_dollar_boom": {
        stop: [0],
        //anim: madnes_fill_range(0, 34)
        anim: madnes_fill_range(0, 24)
    },
    "symbol_grapes_boom": {
        stop: [0],
        //anim: madnes_fill_range(0, 34)
        anim: madnes_fill_range(0, 24)
    },
    "symbol_cherry_boom": {
        stop: [0],
        //anim: madnes_fill_range(0, 34)
        anim: madnes_fill_range(0, 24)
    },
    "symbol_melone_boom": {
        stop: [0],
        //anim: madnes_fill_range(0, 34)
        anim: madnes_fill_range(0, 24)
    },
    "symbol_orange_boom": {
        stop: [0],
        //anim: madnes_fill_range(0, 34)
        anim: madnes_fill_range(0, 24)
    },
    "symbol_plum_boom": {
        stop: [0],
        //anim: madnes_fill_range(0, 34)
        anim: madnes_fill_range(0, 24)
    },
    "symbol_star_boom": {
        stop: [0],
        //anim: madnes_fill_range(0, 34)
        anim: madnes_fill_range(0, 24)
    },

    "symbol_BAR_bell": {
        stop: [0],
        //anim: madnes_fill_range(0, 34)
        anim: madnes_fill_range(0, 29)
    },
    "symbol_BAR_dollar": {
        stop: [0],
        //anim: madnes_fill_range(0, 34)
        anim: madnes_fill_range(0, 29)
    },
    "symbol_BAR_grapes": {
        stop: [0],
        //anim: madnes_fill_range(0, 34)
        anim: madnes_fill_range(0, 29)
    },
    "symbol_BAR_cherry": {
        stop: [0],
        //anim: madnes_fill_range(0, 34)
        anim: madnes_fill_range(0, 29)
    },
    "symbol_BAR_melone": {
        stop: [0],
        //anim: madnes_fill_range(0, 34)
        anim: madnes_fill_range(0, 29)
    },
    "symbol_BAR_orange": {
        stop: [0],
        //anim: madnes_fill_range(0, 34)
        anim: madnes_fill_range(0, 29)
    },
    "symbol_BAR_plum": {
        stop: [0],
        //anim: madnes_fill_range(0, 34)
        anim: madnes_fill_range(0, 29)
    },
    "symbol_BAR_star": {
        stop: [0],
        //anim: madnes_fill_range(0, 34)
        anim: madnes_fill_range(0, 29)
    }
}

export var icons_tmp = new Array();

export var symbols = new Array();
symbols[0] = -1;
symbols[1] = -1;
symbols[2] = -1;


export var last_symbol = new Array();
last_symbol[0] = -1;
last_symbol[1] = -1;
last_symbol[2] = -1;


var reels_lenghts = new Array();
var reels_pos = new Array();

var img_laoder;

var diry = new Array();

var smoke_manager, smoke_emitter;

function init_game(dname, cfg)
{
    // // madnes_load_init("ice_bar_27", cfg);
    //
    // // madnes_set_page_bg(dname, imgsPath + "web/background.png");
    //
    // // madnes_set_texture_version(17);
    //
    // // madnes_set_ico_size(362, 290 - 90);
    //
    //
    // // madnes_set_win_factors(25, 50, 125);
    // // madnes_set_native_sceen_size(1280, 720);
    // //madnes_set_native_sceen_size(1280, 800);
    //
    // // for(var i in to_load_json)
    // // {
    // //     if(infotexts_languages.indexOf(lang) === -1)
    // //     {
    // //         to_load_json[i] = to_load_json[i].replace("{l}", def_lang);
    // //     }
    // //
    // //     madnes_add_json(i, to_load_json[i]);
    // // }
    // //
    // // for(var i in to_load_audio)
    // // {
    // // 	madnes_add_audio(i, to_load_audio[i]);
    // // }
    // //
    // // for(var i in to_load)
    // // {
    // // 	madnes_add_to_load(i, to_load[i]);
    // // }
    // //
    // // for(var i in to_load_fonts)
    // // {
    // // 	madnes_add_font_to_load(i, to_load_fonts[i]);
    // // }
    // // /*
    // // var timestle = {
    // // 	font: "20px Arial",
    // // 	fill: "#636363",
    // // 	align: "left",
    // // 	boundsAlignH: "left",
    // // 	boundsAlignV: "top",
    // // 	wordWrap: false,
    // // 	wordWrapWidth: 300
    // // }
    // // madnes_set_time_style(timestle);
    // // */
    // // madnes_set_sprite('_sprite', 362, 290);
    // // madnes_set_sprite('_blur', 362, 290);
    // //
    // // madnes_set_sprite('wheel_sprite', 580, 580);
    // // madnes_set_sprite('shot_sprite', 154, 126);
    // // madnes_set_sprite('colt_sprite', 188, 534);
    // // madnes_set_sprite('bonus_Winfont_Big', 64, 108);
    // // madnes_set_sprite('bonus_Winfont_Small', 64, 108);
    // // madnes_set_sprite('big-win_Start_sprite', 1280, 800);
    // // madnes_set_sprite('intro_sprite_', 1280, 800);
    //
    // // madnes_set_default_volume(0.8);
    // /*
    // madnes_set_audio_volume("BACKGROUND", 0);
    // madnes_set_audio_volume("FS_START", 0.6);
    // madnes_set_audio_volume("reels", 0.6);
    // madnes_set_audio_volume("FS_BG", 0.6);
    // */
    //
    // madnes_set_printdesk_function(ib27_print_desk);
    // madnes_set_updatedesk_function(ib27_print_reels);
    // madnes_set_rotate_function(ib27_rotate_run);
    //
    // madnes_set_infomenu_init_function(ib27_infomenu_init);
    // madnes_set_infomenu_open_function(ib27_infomenu_open);
    // madnes_set_infomenu_close_function(ib27_infomenu_close);
    // madnes_set_infomenu_update_function(ib27_infomenu_update);
    // madnes_set_infomenu_left_function(ib27_infomenu_left);
    // madnes_set_infomenu_right_function(ib27_infomenu_right);
    //
    // madnes_init(dname);
}

